import RUF from "../../../util/redux";

export function downPaymentGiftedQuestionSave(state, action) {
  return RUF.updateObject(state, {
    model: RUF.updateObject(state.model, {
      downPayment: RUF.updateObject(state.model.downPayment, {
        isGifted: action.payload
      })
    })
  });
}
